import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Table,
  Accordion,
  Form,
  Col,
  Spinner,
  Popover,
  OverlayTrigger,
  Row,
} from "react-bootstrap";
import MaskedInput from "react-text-mask";
import PopUp from "../wdpMap/AlertPopup";
import Alert from "../common/Alert";
import userService from "../../api-service/UserService";
import ShareFieldService from "../../api-service/ShareFieldService";
import SessionHelper from "../../helpers/SessionHelper";
import FluentdHelper from "../../helpers/FluentdHelper";
import DateHelper from "../../helpers/DateHelper";
import {
  ADD_SHARE,
  CHANGE_RIGHTS,
  DANGER,
  DELETE_SHARE,
  EMPTY,
  INFO,
  LOGERROR,
  MC001,
  REMOVE_ON,
  SHARED_FIELDS,
} from "../../configurations/Constants";
import { useSelector } from "react-redux";
import NotifyAdminPopup from "./NotifyAdminPopup";
import {
  ERROR_FETCHING_SHARE_FIELD_DETAILS,
  PLEASE_SELECT_USER,
  FIELD_SHARED_SUCCESSFULLY,
  ALREADY_SHARED_FIELD_WITH,
  ERROR_ADDING_SHARE_FIELD,
  ERROR_STOPPING_SHARED_ACCESS_TO_FIELD,
  REMOVED_ON_STATUS_UPDATED_SUCCESSFULLY,
  SECONDARY_USER_REJECTED_SHARE_FIELD,
  SHARED_FIELD_DELETED_SUCCESSFULLY,
  ERROR_CHANGING_SHARED_FIELD_ACCESS,
  SHARED_FIELD_ACCESS_CHANGES_SUCCESSFULLY,
  USER_WONT_SEE_CROP_FROM_NEXT_SEASON,
  DO_YOU_WANT_TO_CHANGE_ACCESS,
  SHARE_FIELD_WITH,
  CANNOT_SHARE_FIELD_WITH_YOURSELF,
  SELECT_USER_TO_SHARE_FIELD_WITH,
  EMAIL_SENT_SUCCESSFULLY,
  ERROR_DELETING_SHARED_FIELD,
  ERROR_SEARCHING_USER,
  DELETE_RECORD,
  DELETE_RECORD_CONFIRMATION,
  ENTER_MOBILE_NUMBER,
  INVALID_MOBILE_NUMBER,
  FIELD_IS_SHARED_BY,
  SHARED_FIELD_NAME_IS,
} from "../../configurations/MessageConstants";
import { ThreeDots } from "react-loader-spinner";
import { StatusCodes } from "../../configurations/status-codes";
function TabSharedFieldDetails(props) {
  const loggedInUser = useSelector((state) => state.user.loggedInUser);

  const chkshareuser = useRef(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [confirmPopupMessage, setConfirmPopupMessage] = useState(EMPTY);
  const [header, setHeader] = useState(EMPTY);
  const [shareFieldData, setShareFieldData] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(EMPTY);
  const [validated, setValidated] = useState(false);
  const [sharedUser, setSharedUser] = useState(EMPTY);
  const [shareUserDetails, setShareUserDetails] = useState({});
  const [searchCicked, setSearchCicked] = useState(false);
  const [editor, setEditor] = useState(false);
  const [alertMessage, setAlertMessage] = useState(PLEASE_SELECT_USER);
  const [variant, setVariant] = useState(DANGER);
  const [showAlert, setShowAlert] = useState(false);
  const [shareClicked, setShareClicked] = useState(false);
  const [warningActionType, setWarningActionType] = useState(EMPTY);
  const [checkShareUser, setCheckShareUser] = useState(false);
  const [addShareStatus, setAddShareStatus] = useState(false);
  const [sharedFieldId, setSharedFieldId] = useState(EMPTY);
  const [editorStatus, setEditorStatus] = useState(false);
  const [showNotifyAdminPopup, setShowNotifyAdminPopup] = useState(false);

  useEffect(() => {
    (async function () {
      setLoadingData(true);
      if (!props.sharedField.hasOwnProperty("owner_name")) {
        let shareFieldDataValue = await getFieldShareDetails();
        setShareFieldData(shareFieldDataValue);
      }
      setLoadingData(false);
    })();
  }, []);

  const closeWarningPopup = () => {
    setShowConfirmPopup(false);
    setConfirmPopupMessage(EMPTY);
    setShowWarning(false);
    setHeader(EMPTY);
    setShareClicked(false);
  };

  const closeNotifyAdminPopup = () => {
    setShowNotifyAdminPopup(false);
  };

  const getFieldShareDetails = async () => {
    const irrig_unit_id = props.fieldIrrigUnitId;
    try {
      if (!loggedInUser) return {};
      const payload = {
        user_email: loggedInUser,
        irrig_unit_id: irrig_unit_id,
        keys: [SHARED_FIELDS],
      };
      let response = await userService.getUserFieldDetails(payload);
      const responseData = response.data;
      return response.status === StatusCodes.OK ? responseData : {};
    } catch (error) {
      setSharedUser(EMPTY);
      setShareUserDetails({});
      setAlertMessage(ERROR_FETCHING_SHARE_FIELD_DETAILS);
      setVariant(DANGER);
      setShowAlert(true);

      FluentdHelper.logEvent(
        ERROR_FETCHING_SHARE_FIELD_DETAILS,
        "ShareField_getFieldShareDetails",
        loggedInUser,
        {
          request: {
            user_email: loggedInUser,
            irrig_unit_id: irrig_unit_id,
            keys: [SHARED_FIELDS],
          },
          response: error,
        },
        LOGERROR
      );
    }
  };

  const performWarningAction = async (e, idx) => {
    await SessionHelper.handleRefreshToken();

    if (warningActionType === ADD_SHARE) {
      const user_email = loggedInUser;
      let payload = {
        secondary_user_email: shareUserDetails.user_email,
        share_fields: [
          {
            field_name: props.fieldName,
            field_id: props.fieldId,
            editor: editor === true ? true : false,
          },
        ],
      };
      try {
        await ShareFieldService.addShareFieldDetails(payload);
        setShowConfirmPopup(false);
        setShowWarning(false);
        setHeader(EMPTY);
        setConfirmPopupMessage(EMPTY);
        setAlertMessage(FIELD_SHARED_SUCCESSFULLY);
        setVariant(INFO);
        setShowAlert(true);
        setShareClicked(false);
        setValidated(false);
        setSharedUser(EMPTY);
        setShareUserDetails({});
        setSearchCicked(false);
        setEditor(false);
        setPhoneNumber(EMPTY);
        setWarningActionType(EMPTY);
        setLoadingData(true);
        setCheckShareUser(false);

        let shareFieldDataValue = await getFieldShareDetails();
        setShareFieldData(shareFieldDataValue);
        setLoadingData(false);
      } catch (error) {
        console.error(ERROR_ADDING_SHARE_FIELD, error);
        let respData = error.response.data;
        let alertMessageValue = respData.message.includes("already shared")
          ? `${ALREADY_SHARED_FIELD_WITH} ${sharedUser
              .toString()
              .toUpperCase()}.`
          : respData.message;

        handleCatchErrorLogs(
          error.response.status === StatusCodes.BAD_REQUEST
            ? alertMessageValue
            : ERROR_ADDING_SHARE_FIELD,
          "ShareField_performWarningAction",
          payload,
          respData,
          user_email,
          false
        );
        setShareClicked(false);
        setValidated(false);
      }
    } else if (warningActionType === REMOVE_ON) {
      let id = sharedFieldId;
      const user_email = loggedInUser;
      let payload = {
        shared_field_id: id,
        removed: true,
      };
      let message = ERROR_STOPPING_SHARED_ACCESS_TO_FIELD;
      try {
        await ShareFieldService.updateShareFieldDetails(payload);
        setShowConfirmPopup(false);
        setShowWarning(false);
        setHeader(EMPTY);
        setConfirmPopupMessage(EMPTY);
        setAlertMessage(REMOVED_ON_STATUS_UPDATED_SUCCESSFULLY);
        setVariant(INFO);
        setShowAlert(true);
        setSharedFieldId(EMPTY);
        setWarningActionType(EMPTY);
        setLoadingData(true);

        let shareFieldDataValue = await getFieldShareDetails();
        setShareFieldData(shareFieldDataValue);
        setLoadingData(false);
      } catch (error) {
        let respData = error.response.data;
        if (error.response.status === StatusCodes.BAD_REQUEST) {
          if (respData.message_code === MC001) {
            message = SECONDARY_USER_REJECTED_SHARE_FIELD;
          }
          handleCatchErrorLogs(
            message,
            "ShareField_performWarningAction",
            payload,
            respData,
            user_email,
            false
          );
          setLoadingData(true);
          await handleRefreshData();
        } else {
          handleCatchErrorLogs(
            message,
            "ShareField_performWarningAction",
            payload,
            error,
            user_email,
            true
          );
        }
      }
    } else if (warningActionType === DELETE_SHARE) {
      let id = sharedFieldId;
      const user_email = loggedInUser;
      let payload = {
        shared_field_id: id,
        deleted: true,
      };
      try {
        await ShareFieldService.updateShareFieldDetails(payload);
        setShowConfirmPopup(false);
        setShowWarning(false);
        setHeader(EMPTY);
        setConfirmPopupMessage(EMPTY);
        setAlertMessage(SHARED_FIELD_DELETED_SUCCESSFULLY);
        setVariant(INFO);
        setShowAlert(true);
        setSharedFieldId(EMPTY);
        setWarningActionType(EMPTY);
        setLoadingData(true);
        let shareFieldDataValue = await getFieldShareDetails();
        setShareFieldData(shareFieldDataValue);
        setLoadingData(false);
      } catch (error) {
        let respData = error.response.data;
        if (error.response.status === StatusCodes.BAD_REQUEST) {
          handleCatchErrorLogs(
            ERROR_DELETING_SHARED_FIELD,
            "ShareField_performWarningAction",
            payload,
            respData,
            user_email,
            false
          );
        } else {
          handleCatchErrorLogs(
            ERROR_DELETING_SHARED_FIELD,
            "ShareField_performWarningAction",
            payload,
            error,
            user_email,
            true
          );
        }
      }
    } else if (warningActionType === CHANGE_RIGHTS) {
      let id = sharedFieldId;
      let editorStatusValue = editorStatus === true ? true : false;
      const user_email = loggedInUser;
      let payload = {
        shared_field_id: id,
        editor: editorStatusValue === true ? false : true,
      };
      let message = ERROR_CHANGING_SHARED_FIELD_ACCESS;
      try {
        await ShareFieldService.updateShareFieldDetails(payload);
        setShowConfirmPopup(false);
        setShowWarning(false);
        setHeader(EMPTY);
        setConfirmPopupMessage(EMPTY);
        setAlertMessage(SHARED_FIELD_ACCESS_CHANGES_SUCCESSFULLY);
        setVariant(INFO);
        setShowAlert(true);
        setSharedFieldId(EMPTY);
        setWarningActionType(EMPTY);
        setLoadingData(true);
        setEditorStatus(false);

        let shareFieldDataValue = await getFieldShareDetails();
        setShareFieldData(shareFieldDataValue);
        setLoadingData(false);
      } catch (error) {
        let respData = error.response.data;
        if (error.response.status === StatusCodes.BAD_REQUEST) {
          if (respData.message_code === MC001) {
            message = SECONDARY_USER_REJECTED_SHARE_FIELD;
          }
          handleCatchErrorLogs(
            message,
            "ShareField_performWarningAction",
            payload,
            respData,
            user_email,
            false
          );
          setLoadingData(true);
          await handleRefreshData();
        } else {
          handleCatchErrorLogs(
            message,
            "ShareField_performWarningAction",
            payload,
            error,
            user_email,
            true
          );
        }
      }
    }
  };

  const handleRefreshData = async () => {
    let shareFieldDataValue = await getFieldShareDetails();
    setShareFieldData(shareFieldDataValue);
    setLoadingData(false);
  };

  const handleCatchErrorLogs = (
    errormessage,
    actionMethod,
    payload,
    e,
    user_email,
    sendFluentd
  ) => {
    setShowConfirmPopup(false);
    setShowWarning(false);
    setHeader(EMPTY);
    setConfirmPopupMessage(EMPTY);
    setAlertMessage(errormessage);
    setVariant(DANGER);
    setShowAlert(true);

    if (sendFluentd === true) {
      FluentdHelper.logEvent(
        errormessage,
        actionMethod,
        user_email,
        {
          request: payload,
          response: e,
        },
        LOGERROR
      );
    }
  };

  const handleStopSharing = (sharedFieldIdValue) => {
    setShowConfirmPopup(true);
    setShowWarning(true);
    setHeader("Do you want to stop sharing from now?");
    setWarningActionType(REMOVE_ON);
    setSharedFieldId(sharedFieldIdValue);
    setConfirmPopupMessage(USER_WONT_SEE_CROP_FROM_NEXT_SEASON);
  };
  const handleChangeAccess = (sharedFieldIdValue, editorStatusValue) => {
    setShowConfirmPopup(true);
    setShowWarning(true);
    setWarningActionType(CHANGE_RIGHTS);
    setSharedFieldId(sharedFieldIdValue);
    setEditorStatus(editorStatusValue);
    setHeader(DO_YOU_WANT_TO_CHANGE_ACCESS);
    setConfirmPopupMessage(
      `Currently, the user has ${
        editorStatusValue ? "Editor" : "View only"
      } access, do you want to change it to the ${
        editorStatusValue ? "View only" : "Editor"
      } ?`
    );
  };
  const handleDeleteSharing = (sharedFieldIdValue) => {
    setShowConfirmPopup(true);
    setShowWarning(true);
    setWarningActionType(DELETE_SHARE);
    setHeader(DELETE_RECORD_CONFIRMATION);
    setConfirmPopupMessage(DELETE_RECORD);
    setSharedFieldId(sharedFieldIdValue);
  };

  const handleShareFieldConfirmation = () => {
    setShowConfirmPopup(true);
    setShowWarning(true);
    setHeader("Share field");
    setWarningActionType(ADD_SHARE);
    setConfirmPopupMessage(
      `${SHARE_FIELD_WITH} '${sharedUser.toString().toUpperCase()}'?`
    );
  };

  const handlePhoneNumberOnChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    setSharedUser(EMPTY);
    setCheckShareUser(false);
    setShareUserDetails({});
  };

  const handleSearchUser = async (event) => {
    event.persist();
    event.preventDefault();
    event.stopPropagation();
    await SessionHelper.handleRefreshToken();

    const form = event.target;
    setSearchCicked(true);
    setSharedUser(EMPTY);
    setCheckShareUser(false);
    setShareUserDetails({});

    if (form.checkValidity() === false) {
      setValidated(true);
      setSearchCicked(false);
      return false;
    } else {
      const payload = {
        search: [
          {
            key: "PHONE",
            value: phoneNumber.replace(/\D+/g, EMPTY),
          },
        ],
      };
      try {
        const response = await userService.getUserDetails(payload);
        const respData = response.data;

        if (!response || Object.keys(response).length === 0) return;
        let user_name = `${respData.data.first_name}  ${respData.data.last_name}`;
        let user_details = {
          user_id: respData.data.user_id,
          last_name: respData.data.last_name,
          phone: respData.data.phone,
          user_email: respData.data.email,
          first_name: respData.data.first_name,
        };
        setSharedUser(user_name);
        setShareUserDetails(user_details);
        setAlertMessage(EMPTY);
        setVariant(EMPTY);
        setShowAlert(false);
        setCheckShareUser(false);
      } catch (error) {
        console.error(ERROR_SEARCHING_USER, error);
        const responseData = error.response.data;
        if (
          error.response.status === StatusCodes.BAD_REQUEST &&
          responseData.message.includes(CANNOT_SHARE_FIELD_WITH_YOURSELF)
        ) {
          setSharedUser(EMPTY);
          setShareUserDetails({});
          setAlertMessage(responseData.message);
          setVariant(DANGER);
          setShowAlert(true);
        } else if (error.response.status === StatusCodes.BAD_REQUEST) {
          setSharedUser(EMPTY);
          setShareUserDetails({});
          setAlertMessage(responseData.message);
          setVariant(DANGER);
          setShowAlert(false);
          setShowNotifyAdminPopup(true);
        } else {
          FluentdHelper.logEvent(
            ERROR_SEARCHING_USER,
            "ShareField_handleSearchUser",
            "undefined",
            {
              request: payload,
              response: error,
            },
            LOGERROR
          );
        }
      }
      setValidated(false);
      setSearchCicked(false);
    }
  };

  const handleCloseAlert = () => {
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
    setShowAlert(false);
  };

  const handleEditorAccess = () => {
    setEditor(!editor);
  };

  const handleShareField = (e) => {
    setShareClicked(true);
    setCheckShareUser(false);
    let form = e.currentTarget.form;
    if (form.checkValidity() === false) {
      setValidated(true);
      setShareClicked(false);
      return false;
    } else if (
      !chkshareuser.current ||
      chkshareuser.current.checked === false
    ) {
      setAlertMessage(SELECT_USER_TO_SHARE_FIELD_WITH);
      setVariant(DANGER);
      setShowAlert(true);
      setShareClicked(false);
      setValidated(true);
      setCheckShareUser(true);
    } else {
      if (Object.keys(shareUserDetails).length > 0) {
        handleShareFieldConfirmation();
      }
    }
  };

  const handleOpenAddSharePanel = () => {
    setShareClicked(false);
    setValidated(false);
    setSharedUser(EMPTY);
    setShareUserDetails({});
    setSearchCicked(false);
    setEditor(true);
    setPhoneNumber(EMPTY);
    setWarningActionType(EMPTY);
    setCheckShareUser(false);
    setAddShareStatus(!addShareStatus);
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
    setShowAlert(false);
  };

  const handleShareCheckBoxChecked = () => {
    let statusValue = chkshareuser.current.checked ? false : true;
    setCheckShareUser(statusValue);
  };

  const handleAfterSuccessfulEmailSent = () => {
    setAlertMessage(EMAIL_SENT_SUCCESSFULLY);
    setVariant(INFO);
    setShowAlert(true);
    setShareClicked(false);
    setShowNotifyAdminPopup(false);
  };

  const handleGenerateTableRows = (shareFieldData) => {
    if (Object.keys(shareFieldData).length === 0) return [];

    const tableRows = [];
    for (let i = 0; i < shareFieldData.data.shared.length; i++) {
      let rowData = shareFieldData.data.shared[i];
      let sharedFieldIdValue = rowData.shared_field_id;
      let added_date = DateHelper.getDate(
        new Date(rowData.added_on),
        "MMM dd yyyy"
      );
      const removedDate =
        rowData.removed !== null
          ? DateHelper.getDate(new Date(rowData.removed), "MMM dd yyyy")
          : EMPTY;
      const rejected =
        rowData.rejected && rowData.rejected === true ? true : false;

      const editor = rowData.editor === true ? true : false;
      tableRows.push(
        <tr
          key={`sharetablerow${i}`}
          className={
            rowData.rejected && rowData.rejected === true
              ? "rejectedField"
              : EMPTY
          }
        >
          <td className="capitalize">{`${rowData.secondary_user}`}</td>
          <td>{rowData.secondary_user_phone}</td>
          <td> {rowData.field_name}</td>

          <td>{added_date}</td>
          <td>
            <div>
              {rowData.removed === null ? (
                <i
                  className="fa fa-stop-circle"
                  onClick={
                    rejected === false
                      ? () => handleStopSharing(sharedFieldIdValue)
                      : () => {}
                  }
                ></i>
              ) : (
                removedDate
              )}
            </div>
          </td>
          <td>
            <Form.Check
              type="switch"
              checked={editor === true ? true : false}
              onChange={
                removedDate !== EMPTY || rejected === true
                  ? () => {}
                  : () => handleChangeAccess(sharedFieldIdValue, editor)
              }
            />
          </td>
          <td>
            <div className="black-color-i">
              <i
                className="fa fa-close"
                title="DeleteShare"
                onClick={
                  rejected === true
                    ? () => {}
                    : () => handleDeleteSharing(sharedFieldIdValue)
                }
              ></i>
            </div>
          </td>
        </tr>
      );
    }
    return tableRows;
  };
  const tableRows = handleGenerateTableRows(shareFieldData);

  return (
    <div>
      {props.sharedField.hasOwnProperty("owner_name") ? (
        <div id="forSecondaryUser" className="shared-Secondary-User">
          <div className=" text-center">
            <h3>{`${FIELD_IS_SHARED_BY} ${props.sharedField.owner_name}`}</h3>
          </div>
          <div className=" text-center">
            <h4>{`${SHARED_FIELD_NAME_IS}: ${props.sharedField.owner_field_name}`}</h4>
          </div>
        </div>
      ) : (
        <div id="forPrimaryUser">
          {showAlert && (
            <Alert
              key="messageAlert"
              variant={variant}
              closeAlert={(e) => handleCloseAlert(e)}
              alertMessage={alertMessage}
              dismissible
            />
          )}
          <Accordion className="sharefield-accordion mb-4">
            <Accordion.Item eventKey="0">
              <Accordion.Header onClick={() => handleOpenAddSharePanel()}>
                + Add Share
              </Accordion.Header>
              <Accordion.Body>
                <Form
                  id="frmAddShareField"
                  noValidate
                  validated={validated}
                  onSubmit={(e) => handleSearchUser(e)}
                >
                  <Row>
                    <Form.Group controlId="mobile-number" as={Col} md="5">
                      <Form.Label>Mobile Phone Number*</Form.Label>
                      <MaskedInput
                        type="text"
                        size="sm"
                        name="phoneNumber"
                        className="form-control form-control-sm"
                        required
                        value={phoneNumber}
                        onChange={handlePhoneNumberOnChange}
                        pattern="^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$"
                        mask={[
                          "(",
                          /[1-9]/,
                          /\d/,
                          /\d/,
                          ")",
                          " ",
                          /\d/,
                          /\d/,
                          /\d/,
                          "-",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                      />
                      <Form.Control.Feedback type="invalid">
                        {phoneNumber === EMPTY
                          ? ENTER_MOBILE_NUMBER
                          : INVALID_MOBILE_NUMBER}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group
                      controlId="search"
                      as={Col}
                      md="3"
                      className="mt-4 text-start"
                    >
                      <Button type="submit" variant="primary">
                        {searchCicked ? (
                          <div>
                            <Spinner
                              as="span"
                              animation="grow"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{" "}
                            <span>Searching</span>
                          </div>
                        ) : (
                          "Search"
                        )}
                      </Button>
                    </Form.Group>
                    <Form.Group
                      controlId="field-share"
                      as={Col}
                      md="4"
                      className="mt-4 text-start"
                    >
                      {sharedUser !== EMPTY && (
                        <Form.Check
                          name="sharedUserName"
                          label={sharedUser}
                          id="chkshareuser"
                          ref={chkshareuser}
                          onClick={() => {
                            handleShareCheckBoxChecked();
                          }}
                          className={
                            checkShareUser
                              ? "text-uppercase fw-bold shareUsercheckbox color-red"
                              : "text-uppercase fw-bold shareUsercheckbox"
                          }
                        />
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="mt-3">
                    <Form.Group as={Col} md="3">
                      <Button
                        variant="primary"
                        onClick={(e) => handleShareField(e)}
                      >
                        {shareClicked ? (
                          <div>
                            <Spinner
                              as="span"
                              animation="grow"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{" "}
                            <span>Sharing</span>
                          </div>
                        ) : (
                          "Share"
                        )}
                      </Button>{" "}
                    </Form.Group>
                    <Form.Group as={Col} md="2" className="mt-2 d-flex gap-2">
                      <span>Editor</span>
                      <Form.Check
                        type="switch"
                        checked={editor}
                        onChange={() => handleEditorAccess()}
                      />
                    </Form.Group>
                  </Row>
                </Form>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {tableRows.length > 0 ? (
            <div>
              {" "}
              <h4 className="shareTableHeader">
                Fields Shared with:{" "}
                <OverlayTrigger
                  trigger="click"
                  rootClose
                  placement="bottom"
                  overlay={
                    <Popover id="info-popover">
                      <Popover.Body>
                        <p>
                          <b>Shared From:</b> The date the Field was shared with
                          the secondary user. Field data shared will include
                          season/year from the “Shared From” date.
                        </p>
                        <p>
                          <b>Stop Sharing:</b> Ends the FieldShare data sharing
                          with secondary user. If “Stop Sharing” is enabled
                          before April 15th of the year, the Field data for that
                          year (and subsequent years) WILL NOT BE SHARED with
                          the secondary user. If “Stop Sharing” is enabled on or
                          after April 15th of the year, the Field data for that
                          year WILL BE SHARED with the secondary user
                          (subsequent years will not be shared).
                        </p>
                        <p>
                          <b>Editor:</b> As administrator of the Field, you can
                          permit secondary users to add or modify crop details
                          (Crop planted, Crop acres, and/or Tillage). By
                          default, the “Editor” button is turned off and
                          secondary user is not permitted to add or modify crop
                          details. To give secondary user permission to add or
                          modify crop details, turn on the “Editor” button.
                          Please note: “Editor” is only relevant for the current
                          crop year. Secondary users will not have permission to
                          add or modify crop details from past seasons,
                          regardless of whether “Editor” is turned on or off.
                        </p>
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <Button
                    variant="secondary"
                    className="info-button fa fa-info-circle"
                  ></Button>
                </OverlayTrigger>
              </h4>
            </div>
          ) : (
            EMPTY
          )}

          <div
            className={
              addShareStatus
                ? "share-field-details share-field-details-with-addshare"
                : "share-field-details share-field-details-without-addshare"
            }
          >
            {loadingData ? (
              <div className="text-center">
                <ThreeDots color="#00BFFF" height={80} width={80} />
              </div>
            ) : tableRows.length > 0 ? (
              <Table className="table table-striped">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Mobile Number</th>
                    <th>Field Name </th>
                    <th>Shared From</th>
                    <th>Stop Sharing</th>
                    <th>Editor</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody
                  className={
                    addShareStatus
                      ? "shareTable-body-with-addshare"
                      : "shareTable-body"
                  }
                >
                  {tableRows}
                </tbody>
              </Table>
            ) : (
              <h6 align="center" className="chart-title mt-4">
                The field is not shared with anyone yet.
              </h6>
            )}
          </div>
          {showWarning && (
            <PopUp
              showConfirmPopup={showConfirmPopup}
              message={confirmPopupMessage}
              closeWarningPopup={(e) => closeWarningPopup(e)}
              performWarningAction={(e, idx) => performWarningAction(e, idx)}
              header={header}
            />
          )}
          {showNotifyAdminPopup && (
            <NotifyAdminPopup
              showNotifyAdminPopup={showNotifyAdminPopup}
              closePopup={(e) => closeNotifyAdminPopup(e)}
              mobilePhoneNumber={phoneNumber}
              fields={[
                {
                  irrig_unit_id: props.fieldIrrigUnitId,
                  fieldId: props.fieldId,
                  fieldName: props.fieldName,
                },
              ]}
              afterSuccessful={(e) => handleAfterSuccessfulEmailSent()}
            ></NotifyAdminPopup>
          )}
        </div>
      )}
    </div>
  );
}

export default TabSharedFieldDetails;
